// JavaScript Document

const FORMS = document.querySelectorAll(".weblinx-search-form");

FORMS.forEach((form) => {
    const INPUT     = form.querySelector("[name=s]");
    const PROVIDERS = form.querySelectorAll("[name=provider]");

    if (PROVIDERS.length > 0) {
        PROVIDERS.forEach((provider) => {
            provider.addEventListener("change", () => {
                if (provider.dataset.target) {
                    form.setAttribute("target", provider.dataset.target);
                }

                const OPTION = provider.querySelector(`[value=${provider.value}]`);

                if (OPTION) {
                    if (provider.dataset.placeholder) {
                        provider.dataset.placeholder = OPTION.dataset.placeholder;
                    }

                    if (provider.dataset.target) {
                        provider.dataset.target = OPTION.dataset.target;
                    }
                }

                if (provider.dataset.placeholder) {
                    INPUT.placeholder = provider.dataset.placeholder;
                }

                if (provider.dataset.target) {
                    INPUT.target = provider.dataset.target;
                }
            });
        });
    }
});
